import RoleItem from '../Domain/RoleItem';
import AuthService from './authService.js';

class CaspianRoleService {
  static async GetRoleList() {
    const authService = AuthService.getInstance();
    const itemlist = await authService.CallBackendFunction('/api/Role/GetRoles');
    return CaspianRoleService.ConvertDBRole(itemlist);
  }

  static ConvertDBRole(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new RoleItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }
}

export default CaspianRoleService;
